import { useState, useEffect, useRef } from "react";
import dzire     from "../assets/cars/dzire.png";
import innova    from "../assets/cars/innova.png";
import ertiga    from "../assets/cars/ertiga.png";
import aura      from "../assets/cars/aura.png";
import traveller from "../assets/cars/traveller.png";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { FaWhatsapp } from "react-icons/fa";
import { useMemo } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import SEO from "../components/SEO";


const carModels = {
  hatchback: ["Ignis","Tata Tiago","Hyundai Grand i10 Nios","Maruti Baleno","Suzuki Swift"],
  sedan:     ["Honda City","Swift Dzire","Toyota Etios","Hyundai Xcent","Honda Amaze","Hyundai Aura"],
  suv:       ["Maruti XL6","Renault Triber","Toyota Rumion","Maruti Ertiga","Kia Carens"],
  premium_suv: ["Innova Crysta","Mahindra Marazzo","Scorpio N","Innova Hycross"],
};

const PRICE_DETAILS = {
  Hatchback:  { base:9810,  offer:4905, seats:"4+1 seater", car:"Indica Vista, Suzuki Swift, Hyundai Eon, Toyota Liva, Duston Go, Hyundai I10 or Similar",  km:"317 Km", extra:"₹10.5/Km" },
  Sedan:      { base:10024, offer:5012, seats:"4+1 seater", car:"Tata Indigo, Swift Dzire, Toyota Etios, Hyundai Xcent, Honda Amaze, Ford Figo or Similar",   km:"317 Km", extra:"₹10.5/Km" },
  SUV:        { base:13228, offer:6614, seats:"6+1 seater", car:"Toyota Innova, Mahindra Xylo, Tata Aria, Renault Lodgy, Nissan Evalia, Maruti Ertiga or Similar", km:"317 Km", extra:"₹13/Km" },
  PremiumSuv: { base:13228, offer:6614, seats:"6+1 seater", car:"Innova Crysta,Scorpio N,Mahindra Marazzo", km:"317 Km", extra:"₹13/Km" },
};

const VEHICLE_OPTIONS = [
  { id:"Hatchback",  img:aura,   label:"Hatchback"   },
  { id:"Sedan",      img:dzire,  label:"Sedan"       },
  { id:"SUV",        img:ertiga, label:"SUV"         },
  { id:"PremiumSuv", img:innova, label:"Premium Suv" },
];

const SORT_OPTIONS = ["Price: Low to High","Price: High to Low","Rating","ETA"];

const C = { gold:"#f5c518", goldD:"#d4a80f", dark:"#1a1a2e", white:"#ffffff", border:"#e5e7eb", gray:"#6b7280", grayL:"#9ca3af", green:"#22c55e", bg:"#f7f9fc" };
const F = { display:"'Playfair Display', serif", body:"'Plus Jakarta Sans', sans-serif" };

const pad     = n => String(n).padStart(2,"0");
const fmtDate = d => `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
const TODAY   = fmtDate(new Date());

const displayDate = (iso) => {
  if (!iso) return "Today";
  try { return new Date(iso).toLocaleDateString("en-IN",{ day:"numeric", month:"short", year:"numeric" }); }
  catch { return iso; }
};

const calcTripDays = (startDate, returnDate) => {
  if (!startDate || !returnDate) return 1;
  const start = new Date(startDate);
  const end   = new Date(returnDate);
  const diff  = Math.round((end - start) / (1000 * 60 * 60 * 24));
  return diff > 0 ? diff : 1;
};

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800;900&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');

  @keyframes fadeUp    { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
  @keyframes slideDown { from{opacity:0;transform:translateY(-10px)} to{opacity:1;transform:translateY(0)} }
  @keyframes slideUp   { from{opacity:0;transform:translateY(60px)} to{opacity:1;transform:translateY(0)} }
  @keyframes overlayIn { from{opacity:0} to{opacity:1} }
  @keyframes checkPop  { 0%{transform:scale(0) rotate(-20deg)} 70%{transform:scale(1.2) rotate(4deg)} 100%{transform:scale(1) rotate(0)} }
  @keyframes spin      { to{transform:rotate(360deg)} }
  @keyframes stopFadeIn { from{opacity:0;transform:translateY(-6px)} to{opacity:1;transform:translateY(0)} }

  *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
  body { font-family:'Plus Jakarta Sans',sans-serif; overflow-x:hidden; }

  ::-webkit-scrollbar { width:8px; }
  ::-webkit-scrollbar-track { background:#f1f1f1; }
  ::-webkit-scrollbar-thumb { background:#d4a80f; border-radius:10px; }

  .modal-scroll::-webkit-scrollbar { width:6px; }
  .modal-scroll::-webkit-scrollbar-thumb { background:linear-gradient(180deg,#f5c518,#d4a80f); border-radius:10px; }

  .form-field:focus   { border-color:#f5c518 !important; box-shadow:0 0 0 4px rgba(245,197,24,.12) !important; }
  .book-submit:hover  { transform:translateY(-2px) !important; box-shadow:0 10px 32px rgba(245,197,24,.5) !important; }
  .cab-card:hover     { border-color:#f5c518 !important; box-shadow:0 12px 36px rgba(0,0,0,.1) !important; transform:translateY(-2px) !important; }
  .edit-field:focus   { border-color:#f5c518 !important; outline:none; box-shadow:0 0 0 3px rgba(245,197,24,.12) !important; }
  .veh-opt:hover      { border-color:#f5c518 !important; }
  .search-btn:hover   { background:linear-gradient(135deg,#ffd700,#d4a80f) !important; transform:translateY(-1px) !important; }
  .scroll-top:hover   { transform:scale(1.1) !important; }

  .stop-row-edit { animation: stopFadeIn .2s ease; }

  .add-stop-edit:hover {
    border-color:#f5c518 !important;
    color:#b8860b !important;
    background:rgba(245,197,24,.06) !important;
  }

  .trip-type-tab {
    flex:1; padding:9px 0; border:none; border-radius:50px; font-family:'Plus Jakarta Sans',sans-serif;
    font-size:13px; font-weight:700; cursor:pointer; transition:all .22s;
  }
  .trip-type-tab.active {
    background:linear-gradient(135deg,#f5c518,#d4a80f);
    color:#1a1a2e;
    box-shadow:0 4px 14px rgba(245,197,24,.35);
  }
  .trip-type-tab:not(.active) { background:transparent; color:#9ca3af; }

  .trip-summary-bar {
    display:flex; align-items:center; justify-content:space-between; gap:12px;
    background:#fff; border:1px solid #e5e7eb; border-radius:16px;
    padding:14px 18px; margin-bottom:16px;
    box-shadow:0 4px 16px rgba(0,0,0,.06);
    cursor:pointer; transition:border-color .2s, box-shadow .2s;
    animation:fadeUp .4s ease both;
  }
  .trip-summary-bar:hover { border-color:#f5c518; box-shadow:0 6px 24px rgba(245,197,24,.12); }

  .trip-edit-panel { animation:slideDown .3s ease both; margin-bottom:20px; }

  .return-banner {
    background:linear-gradient(135deg,rgba(245,197,24,.12),rgba(212,168,15,.06));
    border:1.5px solid rgba(245,197,24,.4); border-radius:12px;
    padding:10px 14px; margin-top:10px;
    display:flex; align-items:center; gap:8px;
    font-size:12.5px; color:#92400e; font-weight:600;
  }

  @media (max-width:600px) {
    .card-inner     { flex-direction:column !important; }
    .card-left      { padding:14px !important; }
    .card-car-img   { width:90px !important; height:68px !important; min-width:90px !important; }
    .price-panel    { width:100% !important; flex-direction:row !important; justify-content:space-between !important; border-radius:0 0 18px 18px !important; padding:14px 16px !important; }
    .price-btn      { width:auto !important; padding:9px 24px !important; }
    .controls-bar   { flex-direction:column !important; gap:10px !important; }
    .sort-sel       { width:100% !important; }
    .trust-grid     { grid-template-columns:1fr !important; gap:10px !important; }
    .modal-sheet    { border-radius:22px 22px 0 0 !important; max-height:94vh !important; }
    .modal-head     { padding:14px 16px !important; }
    .modal-body-pad { padding:18px 16px 0 !important; }
    .modal-foot     { padding:14px 16px 20px !important; }
    .trip-grid      { grid-template-columns:1fr !important; gap:10px !important; }
    .veh-row        { gap:8px !important; }
    .veh-opt        { width:68px !important; min-width:68px !important; }
    .trip-summary-bar { flex-direction:column !important; align-items:flex-start !important; gap:8px !important; }
  }
`;

const tagStyle = { fontSize:11, background:"#f1f5f9", padding:"4px 8px", borderRadius:6, color:"#475569", whiteSpace:"nowrap" };

/* ── T & C ── */
const TC_INCLUDED = [
  "Vehicle and fuel charges included","Driver Night Charges included",
  "For Round trip bookings, all local sightseeing in mentioned cities is included except pickup city",
  "Toll and state tax included","Driver allowance includes driver's stay, food and night charges",
  "Included Kilometers will start from pickup location",
  "For round trip booking, Kilometers will count from pickup location to pickup location",
];
const TC_EXTRA = [
  "AC will remain switched off in hill areas",
  "One way trip includes only one pickup and one drop — additional pickup or drop on the way will incur charges of ₹250 per pickup/drop",
];

function TandC() {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderRadius:14,overflow:"hidden",border:`1px solid ${open?"#f5c518":"#e5e7eb"}`,transition:"border-color .25s",background:open?"#fffdf0":"#fafafa",marginTop:8 }}>
      <button onClick={()=>setOpen(o=>!o)} style={{ width:"100%",display:"flex",justifyContent:"space-between",alignItems:"center",padding:"13px 14px",background:"none",border:"none",cursor:"pointer",fontFamily:F.body,gap:8 }}>
        <div style={{ display:"flex",alignItems:"center",gap:8,flexWrap:"wrap" }}>
          <span>📋</span>
          <span style={{ fontSize:13,fontWeight:700,color:C.dark }}>Other Charges, Taxes & Terms</span>
          <span style={{ fontSize:10,background:"rgba(245,197,24,.15)",border:"1px solid rgba(245,197,24,.35)",color:"#b8860b",borderRadius:50,padding:"2px 8px",fontWeight:700,textTransform:"uppercase" }}>Must Read</span>
        </div>
        <span style={{ fontSize:18,color:C.gold,fontWeight:300,transition:"transform .25s",display:"inline-block",transform:open?"rotate(45deg)":"none",lineHeight:1,flexShrink:0 }}>+</span>
      </button>
      {open && (
        <div style={{ padding:"0 14px 14px" }}>
          <p style={{ fontSize:11,fontWeight:800,color:"#16a34a",letterSpacing:"1px",textTransform:"uppercase",marginBottom:8 }}>✓ Included in Fare</p>
          {TC_INCLUDED.map((t,i)=>(
            <div key={i} style={{ display:"flex",gap:8,background:"rgba(34,197,94,.05)",border:"1px solid rgba(34,197,94,.15)",borderRadius:10,padding:"8px 10px",marginBottom:6 }}>
              <span style={{ color:"#22c55e",fontSize:13,flexShrink:0,marginTop:1 }}>✔</span>
              <span style={{ fontSize:12,color:"#374151",lineHeight:1.5 }}>{t}</span>
            </div>
          ))}
          <p style={{ fontSize:11,fontWeight:800,color:"#dc2626",letterSpacing:"1px",textTransform:"uppercase",margin:"12px 0 8px" }}>! Additional / Extra Charges</p>
          {TC_EXTRA.map((t,i)=>(
            <div key={i} style={{ display:"flex",gap:8,background:"rgba(239,68,68,.04)",border:"1px solid rgba(239,68,68,.15)",borderRadius:10,padding:"8px 10px",marginBottom:6 }}>
              <span style={{ color:"#ef4444",fontSize:13,flexShrink:0,marginTop:1 }}>✕</span>
              <span style={{ fontSize:12,color:"#374151",lineHeight:1.5 }}>{t}</span>
            </div>
          ))}
          <div style={{ marginTop:10,background:"rgba(245,197,24,.07)",border:"1px solid rgba(245,197,24,.25)",borderRadius:10,padding:"10px 12px",fontSize:11.5,color:"#92400e",lineHeight:1.6 }}>
            ℹ️ By confirming your booking, you agree to the above terms and conditions.
          </div>
        </div>
      )}
    </div>
  );
}

const Inp = ({ id, label, icon, type="text", ph, req, val, onChange, err, ml, im }) => (
  <div style={{ display:"flex",flexDirection:"column",gap:4 }}>
    <label style={{ fontSize:11,fontWeight:700,color:C.dark,letterSpacing:"1px",textTransform:"uppercase",display:"flex",alignItems:"center",gap:5 }}>
      {icon} {label} {req && <span style={{color:"#ef4444"}}>*</span>}
    </label>
    <input id={id} type={type} placeholder={ph} value={val} maxLength={ml} inputMode={im} className="form-field"
      onChange={e => onChange(e.target.value)}
      style={{ padding:"12px 14px",borderRadius:12,border:`1.5px solid ${err?"#ef4444":C.border}`,background:err?"#fff5f5":C.white,fontSize:14,fontFamily:F.body,color:C.dark,outline:"none",transition:"border-color .2s",width:"100%" }}
    />
    {err && <span style={{fontSize:11,color:"#ef4444",fontWeight:600}}>⚠ {err}</span>}
  </div>
);

function BookingFormModal({ driver, trip, onClose }) {
  const navigate = useNavigate();

  const isReturn = !!trip.returnDate;
  const tripDays = isReturn ? calcTripDays(trip.date, trip.returnDate) : 1;
  const basePrice  = Math.round(Number(driver.price || 0));
  const totalPrice = basePrice;

  const details = PRICE_DETAILS[driver.type] || {};
  const [acceptTC, setAcceptTC] = useState(false);
  const [form, setFormState] = useState({
    name:"",
    mobile:"",
    email:"",
    pickup:trip.pickup||"",
    dropoff:trip.destination||"",
    pickupTime: ""
  });
  const [errors, setErrors]      = useState({});
  const [submitted, setSubmitted]= useState(false);
  const [loading, setLoading]    = useState(false);
  const [addons, setAddons]      = useState({ luggage:false, driverLang:false, pet:false });
  const [langChoice, setLangChoice] = useState("English");
  const [openAddons, setOpenAddons] = useState(false);

  const ADDON_P    = { luggage:525, driverLang:840, pet:1050 };
  const addonTotal = Object.entries(addons).reduce((s,[k,v])=>v?s+ADDON_P[k]:s, 0);
  const grandTotal = Math.round(totalPrice + addonTotal);

  const toggleAddon = k => setAddons(a=>({...a,[k]:!a[k]}));
  const set = (k,v) => { setFormState(prev=>({...prev,[k]:v})); setErrors(prev=>({...prev,[k]:""})); };

  useEffect(() => { document.body.style.overflow="hidden"; return () => { document.body.style.overflow="auto"; }; }, []);

  const validate = () => {
    const e = {};
    if (!form.name.trim())                               e.name    = "Full name required";
    if (!/^\d{10}$/.test(form.mobile))                  e.mobile  = "Valid 10-digit number required";
    if (form.email && !/\S+@\S+\.\S+/.test(form.email)) e.email   = "Valid email required";
    if (!form.pickup.trim())                             e.pickup  = "Pickup address required";
    if (!form.dropoff.trim())                            e.dropoff = "Drop address required";
    if (!acceptTC)                                       e.tc      = "Please accept Terms & Conditions";
    if (!form.pickupTime)                                e.pickupTime = "Pickup time required";
    return e;
  };

  const ADDON_ID_MAP = { luggage:1, driverLang:2, pet:3 };

  const submit = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    try {
      setLoading(true);
      const selectedAddons = Object.entries(addons).filter(([,v])=>v).map(([k])=>ADDON_ID_MAP[k]);

      // Pass via_cities from trip state if present
      const viaCities = trip.stops || [];

      const payload = {
        cab:               driver.id,
        full_name:         form.name,
        mobile:            form.mobile,
        email:             form.email,
        pickup_address:    form.pickup,
        drop_address:      form.dropoff,
        departure_date:    trip.date ? trip.date.split("T")[0] : new Date().toISOString().split("T")[0],
        return_date:       trip.returnDate || null,
        trip_days:         tripDays,
        trip_type:         isReturn ? "round" : "one",
        via_cities:        viaCities,          // ← sent to backend
        pickup_time:       form.pickupTime,
        base_fare:         basePrice,
        trip_days_total:   totalPrice,
        addon_total:       Number(addonTotal || 0),
        other_charges:     0,
        total_fare:        Number(grandTotal || 0),
        addons:            selectedAddons,
        driver_language:   addons.driverLang ? langChoice : "",
        pet_allowed:       addons.pet,
        luggage_assistance:addons.luggage,
        trip_distance:     driver.distance || 0,
        eta_minutes:       parseInt(driver.eta) || 0,
      };
      console.log("BOOKING PAYLOAD:", payload);
      await axios.post("https://prashantbha.pythonanywhere.com/api/book/", payload);
      toast.success("Booking Confirmed 🚖");
      setSubmitted(true);
    } catch (err) {
      console.error("BOOKING ERROR:", err.response?.data || err.message);
      toast.error("Booking failed ❌");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) return (
    <div style={{ position:"fixed",inset:0,zIndex:200,display:"flex",alignItems:"center",justifyContent:"center",background:"rgba(10,15,35,.85)",backdropFilter:"blur(10px)",animation:"overlayIn .3s ease" }}>
      <div className="modal-sheet" style={{ background:C.white,borderRadius:"28px",padding:"34px 30px",maxWidth:460,width:"92%",textAlign:"center",boxShadow:"0 -20px 60px rgba(0,0,0,.25)",animation:"slideUp .4s ease",maxHeight:"90vh",overflowY:"auto" }}>
        <div style={{ width:68,height:68,borderRadius:"50%",background:"linear-gradient(135deg,#f5c518,#d4a80f)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:32,margin:"0 auto 14px",animation:"checkPop .5s .1s cubic-bezier(.34,1.56,.64,1) both" }}>🎉</div>
        <h2 style={{ fontFamily:F.display,fontSize:"clamp(20px,5vw,28px)",fontWeight:900,color:C.dark,marginBottom:6 }}>Booking Confirmed!</h2>
        <p style={{ color:C.gray,fontSize:13,marginBottom:20 }}>We will call you Shortly on <strong>+91 {form.mobile}</strong></p>
        <div style={{ background:"#f8f9fd",borderRadius:18,padding:"18px",marginBottom:18,textAlign:"left",border:"1px solid #eef2f7" }}>
          {[
            ["Vehicle",        driver.vehicle],
            ["Name",           form.name],
            ["Mobile",         `+91 ${form.mobile}`],
            ["Trip Type",      isReturn ? `Round Trip (${tripDays} day${tripDays>1?"s":""})` : "One Way"],
            ["Departure Date", displayDate(trip.date || new Date().toISOString())],
            ...(isReturn ? [["Return Date", displayDate(trip.returnDate)]] : []),
            ...((trip.stops||[]).length ? [["Via Cities", (trip.stops||[]).join(" → ")]] : []),
            ["Pickup",         form.pickup],
            ["Drop",           form.dropoff],
            ["Pickup Time",    form.pickupTime],
            ["Trip Fare",      `₹${Math.round(totalPrice).toLocaleString()}`],
            ...(isReturn ? [["Trip Days",`${tripDays} day${tripDays>1?"s":""}`]] : []),
            ...(addonTotal>0 ? [["Add-ons",`₹${addonTotal.toLocaleString()}`]] : []),
            ["Total Fare",     `₹${grandTotal.toLocaleString()}`],
          ].map(([k,v],i,arr)=>(
            <div key={k} style={{ display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:i===arr.length-1?0:10,gap:12,paddingBottom:k==="Total Fare"?0:10,borderBottom:k==="Total Fare"?"none":"1px dashed #e5e7eb" }}>
              <span style={{ color:C.grayL,fontSize:13,fontWeight:600,minWidth:90 }}>{k}</span>
              <span style={{ fontWeight:k==="Total Fare"?900:700,color:k==="Total Fare"?"#16a34a":C.dark,fontSize:k==="Total Fare"?20:13,textAlign:"right",wordBreak:"break-word" }}>{v}</span>
            </div>
          ))}
        </div>
        <button onClick={()=>{ onClose(); navigate("/"); }} style={{ background:`linear-gradient(135deg,${C.gold},${C.goldD})`,color:C.dark,border:"none",borderRadius:50,padding:"16px 40px",fontWeight:800,fontFamily:F.display,fontSize:16,cursor:"pointer",width:"100%" }}>Done ✓</button>
      </div>
    </div>
  );

  return (
    <div style={{ position:"fixed",inset:0,zIndex:200,display:"flex",alignItems:"center",justifyContent:"center",background:"rgba(10,15,35,.82)",backdropFilter:"blur(10px)",animation:"overlayIn .3s ease" }} onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal-sheet" style={{ background:C.white,borderRadius:"28px",maxWidth:520,width:"100%",boxShadow:"0 -20px 60px rgba(0,0,0,.25)",animation:"slideUp .4s ease",overflow:"hidden",maxHeight:"92vh",display:"flex",flexDirection:"column" }}>
        <div style={{ display:"flex",justifyContent:"center",padding:"10px 0 4px",flexShrink:0 }}><div style={{ width:40,height:4,borderRadius:2,background:"#d1d5db" }} /></div>
        <div className="modal-head" style={{ background:`linear-gradient(135deg,${C.dark},#2d3a6b)`,padding:"16px 22px",display:"flex",alignItems:"center",gap:14,flexShrink:0 }}>
          <img src={driver.img} alt={driver.vehicle} style={{ width:64,height:48,objectFit:"contain",background:"rgba(255,255,255,.08)",borderRadius:10,padding:6,flexShrink:0 }} />
          <div style={{ flex:1,minWidth:0 }}>
            <div style={{ fontFamily:F.display,fontSize:"clamp(14px,3.5vw,18px)",fontWeight:800,color:C.white,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap" }}>{driver.vehicle}</div>
            <div style={{ display:"flex",gap:10,marginTop:5,alignItems:"center",flexWrap:"wrap" }}>
              <span style={{ fontSize:13,fontWeight:800,color:C.gold }}>₹{Math.round(basePrice).toLocaleString()}</span>
            </div>
          </div>
          <button onClick={onClose} style={{ background:"rgba(255,255,255,.1)",border:"none",color:"rgba(255,255,255,.7)",borderRadius:"50%",width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:16,flexShrink:0 }}>✕</button>
        </div>

        <div className="modal-body-pad modal-scroll" style={{ overflowY:"auto",padding:"20px 22px 0",flex:1 }}>
          <h3 style={{ fontFamily:F.display,fontSize:"clamp(18px,4.5vw,22px)",fontWeight:800,color:C.dark,marginBottom:4 }}>Complete Your Booking</h3>
          <p style={{ fontSize:13,color:C.grayL,marginBottom:18 }}>Fill in your details and we'll confirm instantly.</p>

          {/* Return trip banner */}
          {isReturn && (
            <div className="return-banner" style={{ marginBottom:16 }}>
              <span style={{ fontSize:20 }}>🔁</span>
              <div>
                <span style={{ fontWeight:800 }}>Round Trip · {tripDays} Day{tripDays>1?"s":""}</span>
                <span style={{ color:"#a16207",fontWeight:500 }}>
                  {" "}({displayDate(trip.date)} → {displayDate(trip.returnDate)})
                </span>
                <div style={{ fontSize:11.5,marginTop:2,color:"#92400e" }}>
                  <strong>₹{Math.round(totalPrice).toLocaleString()}</strong>
                </div>
              </div>
            </div>
          )}

          {/* Via cities banner */}
          {(trip.stops||[]).length > 0 && (
            <div style={{ background:"rgba(245,197,24,.08)",border:"1.5px solid rgba(245,197,24,.3)",borderRadius:12,padding:"10px 14px",marginBottom:16,display:"flex",alignItems:"flex-start",gap:8 }}>
              <span style={{ fontSize:18,flexShrink:0 }}>📍</span>
              <div>
                <div style={{ fontSize:12,fontWeight:800,color:C.dark,marginBottom:3 }}>Via Cities</div>
                <div style={{ fontSize:12,color:C.gray }}>{(trip.stops||[]).join(" → ")}</div>
              </div>
            </div>
          )}

          <div style={{ display:"flex",flexDirection:"column",gap:13,marginBottom:18 }}>
            <Inp id="name"   label="Full Name"        icon="👤" ph="e.g. Ravi Mehta"     req val={form.name}   onChange={v=>set("name",v)}                    err={errors.name}   />
            <Inp id="mobile" label="Mobile Number"    icon="📱" type="tel" ph="10-digit"  req val={form.mobile} onChange={v=>set("mobile",v.replace(/\D/g,""))} err={errors.mobile} ml={10} im="numeric" />
            <Inp id="email"  label="Email (Optional)" icon="✉️" type="email" ph="you@example.com" val={form.email} onChange={v=>set("email",v)} err={errors.email} />
            <div style={{ display:"flex",alignItems:"center",gap:10,margin:"2px 0" }}>
              <div style={{ flex:1,height:1,background:C.border }} />
              <span style={{ fontSize:11,color:C.grayL,fontWeight:600,letterSpacing:"1px",textTransform:"uppercase",whiteSpace:"nowrap" }}>Trip Details</span>
              <div style={{ flex:1,height:1,background:C.border }} />
            </div>
            <div style={{ display:"flex",flexDirection:"column",gap:4 }}>
              <label style={{ fontSize:11,fontWeight:700,color:C.dark,letterSpacing:"1px",textTransform:"uppercase" }}>📍 Pickup Address <span style={{color:"#ef4444"}}>*</span></label>
              <textarea placeholder="Full pickup address with landmark..." value={form.pickup} onChange={e=>set("pickup",e.target.value)} className="form-field" rows={2} style={{ padding:"12px 14px",borderRadius:12,border:`1.5px solid ${errors.pickup?"#ef4444":C.border}`,background:errors.pickup?"#fff5f5":C.white,fontSize:14,fontFamily:F.body,color:C.dark,outline:"none",width:"100%",resize:"none",lineHeight:1.5 }} />
              {errors.pickup && <span style={{fontSize:11,color:"#ef4444",fontWeight:600}}>⚠ {errors.pickup}</span>}
            </div>
            <div style={{ display:"flex",flexDirection:"column",gap:4 }}>
              <label style={{ fontSize:11,fontWeight:700,color:C.dark,letterSpacing:"1px",textTransform:"uppercase" }}>🏁 Drop Address <span style={{color:"#ef4444"}}>*</span></label>
              <textarea placeholder="Full drop address with landmark..." value={form.dropoff} onChange={e=>set("dropoff",e.target.value)} className="form-field" rows={2} style={{ padding:"12px 14px",borderRadius:12,border:`1.5px solid ${errors.dropoff?"#ef4444":C.border}`,background:errors.dropoff?"#fff5f5":C.white,fontSize:14,fontFamily:F.body,color:C.dark,outline:"none",width:"100%",resize:"none",lineHeight:1.5 }} />
              {errors.dropoff && <span style={{fontSize:11,color:"#ef4444",fontWeight:600}}>⚠ {errors.dropoff}</span>}
            </div>
          </div>

          <div style={{ display:"flex",flexDirection:"column",gap:4,marginBottom:12 }}>
            <label style={{ fontSize:11,fontWeight:700,color:C.dark,letterSpacing:"1px",textTransform:"uppercase" }}>⏰ Pickup Time <span style={{color:"#ef4444"}}>*</span></label>
            <input type="time" value={form.pickupTime} onChange={(e)=>set("pickupTime",e.target.value)} className="form-field"
              style={{ padding:"12px 14px",borderRadius:12,border:`1.5px solid ${errors.pickupTime?"#ef4444":C.border}`,background:errors.pickupTime?"#fff5f5":C.white,fontSize:14,fontFamily:F.body,color:C.dark,outline:"none",width:"100%" }} />
            {errors.pickupTime && <span style={{fontSize:11,color:"#ef4444",fontWeight:600}}>⚠ {errors.pickupTime}</span>}
          </div>

          {/* Add-ons */}
          <div style={{ marginBottom:12 }}>
            <div style={{ borderRadius:14,marginTop:8,overflow:"hidden",border:`1px solid ${openAddons?"#f5c518":"#e5e7eb"}`,transition:"border-color .25s",background:openAddons?"#fffdf0":"#fafafa",marginBottom:12 }}>
              <button onClick={()=>setOpenAddons(!openAddons)} style={{ width:"100%",display:"flex",justifyContent:"space-between",alignItems:"center",padding:"13px 14px",background:"none",border:"none",cursor:"pointer",fontFamily:F.body,gap:8 }}>
                <div style={{ display:"flex",alignItems:"center",gap:8,flexWrap:"wrap" }}>
                  <span>➕</span>
                  <span style={{ fontSize:13,fontWeight:700,color:C.dark }}>Add On Service</span>
                  <span style={{ fontSize:10,background:"rgba(245,197,24,.15)",border:"1px solid rgba(245,197,24,.35)",color:"#b8860b",borderRadius:50,padding:"2px 8px",fontWeight:700,textTransform:"uppercase" }}>Optional</span>
                </div>
                <span style={{ fontSize:18,color:C.gold,fontWeight:300,transition:"transform .25s",display:"inline-block",transform:openAddons?"rotate(45deg)":"none",lineHeight:1 }}>+</span>
              </button>
              {openAddons && (
                <div style={{ padding:"0 14px 14px" }}>
                  {[{ key:"luggage", label:"🧳 Assured luggage space", price:"₹525" },{ key:"pet", label:"🐾 Pet Allowed", price:"₹1,050" }].map(item=>(
                    <label key={item.key} style={{ display:"flex",alignItems:"flex-start",gap:12,padding:"12px 0",borderBottom:"1px dashed #e5e7eb",cursor:"pointer" }}>
                      <input type="checkbox" checked={addons[item.key]} onChange={()=>toggleAddon(item.key)} style={{ width:17,height:17,accentColor:C.gold,marginTop:2,cursor:"pointer" }} />
                      <div style={{ flex:1 }}>
                        <div style={{ display:"flex",justifyContent:"space-between",gap:10 }}>
                          <span style={{ fontSize:13,color:C.dark,fontWeight:600 }}>{item.label}</span>
                          <span style={{ fontSize:13,fontWeight:800,color:C.goldD }}>{item.price}</span>
                        </div>
                      </div>
                    </label>
                  ))}
                  <div style={{ padding:"12px 0 4px" }}>
                    <label style={{ display:"flex",alignItems:"flex-start",gap:12,cursor:"pointer" }}>
                      <input type="checkbox" checked={addons.driverLang} onChange={()=>toggleAddon("driverLang")} style={{ width:17,height:17,accentColor:C.gold,marginTop:2 }} />
                      <div style={{ flex:1 }}>
                        <div style={{ display:"flex",justifyContent:"space-between",gap:10 }}>
                          <span style={{ fontSize:13,color:C.dark,fontWeight:600 }}>🗣️ Preferred Driver Language</span>
                          <span style={{ fontSize:13,fontWeight:800,color:C.goldD }}>₹840</span>
                        </div>
                      </div>
                    </label>
                    {addons.driverLang && (
                      <div style={{ display:"flex",gap:18,padding:"12px 0 0 30px",flexWrap:"wrap" }}>
                        {["English","Hindi","Gujarati"].map(l=>(
                          <label key={l} style={{ display:"flex",alignItems:"center",gap:5,cursor:"pointer",fontSize:13,color:C.dark }}>
                            <input type="radio" name="driverLang" value={l} checked={langChoice===l} onChange={()=>setLangChoice(l)} style={{ accentColor:C.gold,width:14,height:14 }} />
                            {l}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                  {addonTotal>0 && (
                    <div style={{ marginTop:12,background:"rgba(245,197,24,.08)",border:"1px solid rgba(245,197,24,.2)",borderRadius:10,padding:"10px 12px",display:"flex",justifyContent:"space-between",alignItems:"center" }}>
                      <span style={{ fontSize:12,color:C.dark,fontWeight:700 }}>Add-on Total</span>
                      <span style={{ fontSize:14,color:C.goldD,fontWeight:800 }}>+₹{addonTotal.toLocaleString()}</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          <TandC />
          <div style={{ display:"flex",alignItems:"flex-start",gap:10,marginTop:12 }}>
            <input type="checkbox" checked={acceptTC} onChange={()=>setAcceptTC(!acceptTC)} style={{ width:18,height:18,accentColor:C.gold,cursor:"pointer",marginTop:2 }} />
            <span style={{ fontSize:12,color:"#374151",lineHeight:1.5 }}>
              I agree to the{" "}
              <span onClick={()=>window.open("/#terms","_blank")} style={{ color:C.goldD,fontWeight:700,cursor:"pointer",textDecoration:"underline" }}>Terms & Conditions</span>
              {" "}and understand all charges, policies, and cancellation rules.
            </span>
          </div>
          {errors.tc && <span style={{ fontSize:11,color:"#ef4444",fontWeight:600 }}>⚠ {errors.tc}</span>}
          <div style={{ height:20 }} />
        </div>

        <div className="modal-foot" style={{ padding:"14px 22px 22px",flexShrink:0,borderTop:`1px solid ${C.border}`,background:C.white }}>
          <div style={{ background:"#f8f9fd",borderRadius:12,padding:"11px 14px",marginBottom:12 }}>
            <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center" }}>
              <div>
                <div style={{ fontSize:10,color:C.grayL,fontWeight:700,textTransform:"uppercase",letterSpacing:"1px" }}>
                  {isReturn ? `Total Fare (${tripDays} day${tripDays>1?"s":""})` : "Total Fare"}
                </div>
                <div style={{ display:"flex",alignItems:"baseline",gap:6 }}>
                  <span style={{ fontFamily:F.display,fontSize:"clamp(20px,5vw,26px)",fontWeight:900,color:C.dark }}>₹{grandTotal.toLocaleString()}</span>
                  <span style={{ fontSize:11,color:C.grayL,textDecoration:"line-through" }}>₹{Math.round(grandTotal * 2).toLocaleString()}</span>
                </div>
                {isReturn && (
                  <div style={{ fontSize:11,color:C.goldD,fontWeight:600,marginTop:2 }}>
                    {addonTotal>0?` + ₹${addonTotal} add-ons`:""}
                  </div>
                )}
              </div>
              <div style={{ textAlign:"right" }}>
                <div style={{ fontSize:11,color:C.green,fontWeight:700 }}>✔ Toll, Fuel & Driver</div>
                <div style={{ fontSize:10,color:C.grayL }}>Included in fare</div>
              </div>
            </div>
          </div>
          <button onClick={submit} disabled={loading||!acceptTC} className="book-submit"
            style={{ width:"100%",padding:"15px",borderRadius:50,border:"none",background:(!acceptTC||loading)?"#e5e7eb":`linear-gradient(135deg,${C.gold},${C.goldD})`,color:(!acceptTC||loading)?"#9ca3af":C.dark,cursor:(!acceptTC||loading)?"not-allowed":"pointer",fontSize:"clamp(14px,4vw,16px)",fontWeight:800,fontFamily:F.display,boxShadow:"0 6px 28px rgba(245,197,24,.35)",transition:"all .25s",display:"flex",alignItems:"center",justifyContent:"center",gap:10 }}>
            {loading?<><span style={{ display:"inline-block",width:18,height:18,border:"2.5px solid #9ca3af",borderTopColor:"transparent",borderRadius:"50%",animation:"spin .7s linear infinite" }} />Confirming…</>:<>🚗 Confirm Booking · ₹{grandTotal.toLocaleString()}</>}
          </button>
          <p style={{ textAlign:"center",fontSize:11,color:C.grayL,marginTop:10 }}>🔒 Your details are safe · No spam calls guaranteed</p>
        </div>
      </div>
    </div>
  );
}

/* ── Cab Card ── */
function CabCard({ driver, onBook, tripDays }) {
  const details     = PRICE_DETAILS[driver.type] || {};
  const displayPrice = Math.round(driver.price);
  return (
    <div className="cab-card" style={{ borderRadius:20,background:C.white,border:`1px solid ${C.border}`,boxShadow:"0 6px 25px rgba(0,0,0,.07)",transition:"all .3s",overflow:"hidden" }}>
      <div className="card-inner" style={{ display:"flex",justifyContent:"space-between",alignItems:"stretch" }}>
        <div className="card-left" style={{ display:"flex",gap:14,flex:1,padding:18,minWidth:0 }}>
          <div className="card-car-img" style={{ width:118,minWidth:118,height:88,borderRadius:14,background:"linear-gradient(135deg,#f8fafc,#eef2f7)",border:`1px solid ${C.border}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0 }}>
            <img src={driver.img} alt={`${driver.vehicle} cab for hire`} style={{ width:100,height:72,objectFit:"contain" }} />
          </div>
          <div style={{ flex:1,minWidth:0 }}>
            <div style={{ display:"flex",alignItems:"center",gap:7,flexWrap:"wrap",marginBottom:3 }}>
              <span style={{ fontWeight:700,fontSize:"clamp(14px,3vw,16px)",color:C.dark }}>{driver.vehicle}</span>
              {driver.badge && <span style={{ fontSize:10,background:driver.badgeColor+"22",color:driver.badgeColor,border:`1px solid ${driver.badgeColor}44`,borderRadius:50,padding:"2px 8px",fontWeight:700 }}>{driver.badge}</span>}
              {tripDays > 1 && (
                <span style={{ fontSize:10,background:"rgba(245,197,24,.15)",color:"#b8860b",border:"1px solid rgba(245,197,24,.35)",borderRadius:50,padding:"2px 8px",fontWeight:700 }}>🔁 {tripDays}-Day Trip</span>
              )}
            </div>
            <div style={{ marginTop:7,fontSize:11.5,color:"#374151" }}><b>{driver.type}</b> (AC) · {details.seats} · 🚗 {driver.distance.toFixed(1)} Km approx · ➕ ₹{driver.price_per_km}/Km</div>
            <div style={{ marginTop:8,fontSize:13,color:"#666",lineHeight:"20px" }}>
              {carModels[driver.type?.toLowerCase()]?.join(", ")}
              <div style={{ marginTop:4,color:"#16a34a",fontSize:12,fontWeight:500 }}>✓ Toll, Fuel, Driver included</div>
            </div>
          </div>
        </div>
        <div className="price-panel" style={{ width:155,textAlign:"center",borderRadius:"0 18px 18px 0",padding:14,background:"linear-gradient(135deg,#111827,#1f2937)",color:C.white,flexShrink:0,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:3 }}>
          <div>
            <span style={{ fontSize:10,background:"#16a34a",padding:"3px 8px",borderRadius:20,fontWeight:700,display:"inline-block" }}>BEST PRICE</span>
            <div style={{ fontSize:12,textDecoration:"line-through",color:"#9ca3af",marginTop:4 }}>₹{Math.round(displayPrice * 2)}</div>
            <div style={{ fontSize:"clamp(20px,4vw,26px)",fontWeight:800,color:"#facc15",lineHeight:1.1 }}>₹{displayPrice}</div>
            {tripDays > 1 && (
              <div style={{ fontSize:10,color:"rgba(245,197,24,.7)",marginTop:2 }}>Final Round Trip Price</div>
            )}
            <div style={{ fontSize:12,color:C.green,marginBottom:8 }}>
              ETA: {(() => { const mins=parseInt(driver.eta); return !isNaN(mins) ? mins>=60 ? `${Math.floor(mins/60)}hr ${mins%60}m` : `${mins} min` : "N/A"; })()}
            </div>
          </div>
          {driver.status?.toLowerCase() === "available" ? (
            <button className="price-btn" onClick={()=>onBook(driver)} style={{ padding:"9px 18px",borderRadius:30,border:"none",background:C.gold,fontWeight:700,cursor:"pointer",color:"#111",fontSize:13,fontFamily:F.body,transition:"all .2s",width:"100%" }}>Book Now</button>
          ) : (
            <button disabled style={{ padding:"10px 14px",borderRadius:30,border:"none",background:"#ef4444",color:"#fff",fontWeight:700,width:"100%",cursor:"not-allowed",fontSize:12 }}>All Booked</button>
          )}
        </div>
      </div>
    </div>
  );
}

/* ── Trip Edit Panel (with via stops) ── */
function TripEditPanel({ tripState, setTripState, onSearch, pickupRef, dropRef, stopRefs, onClose }) {
  const { pickup, destination, date, returnDate, tripType, stops } = tripState;

  // Add a new stop
  const addStop = () => {
    if (stops.length >= 5) return;
    setTripState(s => ({ ...s, stops: [...s.stops, { id: Date.now(), value: "" }] }));
  };

  // Remove a stop
  const removeStop = (id) => {
    setTripState(s => ({ ...s, stops: s.stops.filter(st => st.id !== id) }));
    delete stopRefs.current[id];
  };

  // Update a stop's value
  const updateStop = (id, value) => {
    setTripState(s => ({ ...s, stops: s.stops.map(st => st.id === id ? { ...st, value } : st) }));
  };

  return (
    <div className="trip-edit-panel" style={{ background:C.white,border:`1.5px solid ${C.gold}`,borderRadius:20,padding:"22px 24px",boxShadow:"0 8px 32px rgba(245,197,24,.12)",marginBottom:20 }}>
      <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:18 }}>
        <div style={{ display:"flex",alignItems:"center",gap:10 }}>
          <div style={{ width:36,height:36,borderRadius:10,background:`linear-gradient(135deg,${C.gold},${C.goldD})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:17 }}>✏️</div>
          <div>
            <div style={{ fontFamily:F.display,fontWeight:800,fontSize:16,color:C.dark }}>Modify Your Trip</div>
            <div style={{ fontSize:11,color:C.grayL }}>Change pickup, destination, date or vehicle</div>
          </div>
        </div>
        <button onClick={onClose} style={{ background:"#f3f4f6",border:"none",width:32,height:32,borderRadius:"50%",cursor:"pointer",fontSize:16,color:C.gray,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0 }}>✕</button>
      </div>

      {/* One Way / Round Trip Toggle */}
      <div style={{ display:"flex",background:"#f3f4f6",borderRadius:50,padding:4,marginBottom:16,gap:4 }}>
        <button className={`trip-type-tab${tripType==="one"?" active":""}`}
          onClick={() => setTripState(s => ({ ...s, tripType:"one", stops:[] }))}>
          🛫 Outstation
        </button>
        <button className={`trip-type-tab${tripType==="round"?" active":""}`}
          onClick={() => setTripState(s => ({ ...s, tripType:"round" }))}>
          🔁 Round Trip
        </button>
      </div>

      {/* Pickup + Destination */}
      <div className="trip-grid" style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14 }}>
        <div style={{ display:"flex",flexDirection:"column",gap:5 }}>
          <label style={{ fontSize:10,fontWeight:800,color:C.grayL,letterSpacing:"1.5px",textTransform:"uppercase" }}>📍 Pickup Location</label>
          <input type="text" ref={pickupRef} value={pickup} onChange={e=>setTripState(s=>({...s,pickup:e.target.value}))} placeholder="Enter pickup" className="edit-field"
            style={{ padding:"12px 14px",borderRadius:12,border:`1.5px solid ${C.border}`,fontSize:14,fontFamily:F.body,color:C.dark,background:"#f8f9fd",width:"100%" }} />
        </div>
        <div style={{ display:"flex",flexDirection:"column",gap:5 }}>
          <label style={{ fontSize:10,fontWeight:800,color:C.grayL,letterSpacing:"1.5px",textTransform:"uppercase" }}>🏁 Destination</label>
          <input type="text" ref={dropRef} value={destination} onChange={e=>setTripState(s=>({...s,destination:e.target.value}))} placeholder="Enter destination" className="edit-field"
            style={{ padding:"12px 14px",borderRadius:12,border:`1.5px solid ${C.border}`,fontSize:14,fontFamily:F.body,color:C.dark,background:"#f8f9fd",width:"100%" }} />
        </div>
      </div>

      {/* ── Via Stops (both trip types) ── */}
      {tripType === "round" && (
        <div style={{ marginBottom:14 }}>
        {stops.length > 0 && (
          <div style={{ fontSize:10,fontWeight:800,color:C.grayL,letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:8 }}>
            📍 Via Cities
          </div>
        )}

        {stops.map((stop, idx) => (
          <div
            key={stop.id}
            className="stop-row-edit"
            style={{ display:"flex",alignItems:"center",gap:8,marginBottom:10 }}
          >
            {/* Gold dot connector */}
            <div style={{ width:8,height:8,borderRadius:"50%",background:C.gold,border:`2px solid ${C.goldD}`,flexShrink:0 }} />

            {/* Stop input */}
            <div style={{ position:"relative",flex:1 }}>
              <input
                type="text"
                ref={el => { if (el) stopRefs.current[stop.id] = el; }}
                placeholder={`Via city ${idx + 1} (e.g. Rajkot)`}
                value={stop.value}
                onChange={e => updateStop(stop.id, e.target.value)}
                className="edit-field"
                style={{ width:"100%",padding:"11px 38px 11px 14px",borderRadius:12,border:`1.5px solid ${C.gold}55`,fontSize:13,fontFamily:F.body,color:C.dark,background:"#fffdf0" }}
              />
            </div>

            {/* Remove button */}
            <button
              onClick={() => removeStop(stop.id)}
              title="Remove stop"
              style={{ width:30,height:30,borderRadius:"50%",border:`1px solid ${C.border}`,background:"#fff",cursor:"pointer",fontSize:13,display:"flex",alignItems:"center",justifyContent:"center",color:C.gray,flexShrink:0,transition:"all .2s" }}
              onMouseEnter={e=>{ e.currentTarget.style.background="#fee2e2"; e.currentTarget.style.color="#dc2626"; e.currentTarget.style.borderColor="#fca5a5"; }}
              onMouseLeave={e=>{ e.currentTarget.style.background="#fff"; e.currentTarget.style.color=C.gray; e.currentTarget.style.borderColor=C.border; }}
            >✕</button>
          </div>
        ))}

        {/* Add stop button */}
        {stops.length < 5 && (
          <button
            onClick={addStop}
            className="add-stop-edit"
            style={{ width:"100%",border:`1.5px dashed ${C.border}`,borderRadius:12,background:"transparent",cursor:"pointer",padding:"10px 14px",fontSize:13,color:C.gray,display:"flex",alignItems:"center",gap:8,fontFamily:F.body,fontWeight:600,transition:"all .2s",marginBottom:2 }}
          >
            <span style={{ fontSize:17,lineHeight:1,color:C.goldD }}>＋</span>
            Add via city {stops.length > 0 ? `(${stops.length}/5)` : ""}
          </button>
        )}

        {stops.length >= 5 && (
          <p style={{ fontSize:12,color:C.grayL,textAlign:"center",marginTop:4 }}>Maximum 5 via cities added</p>
        )}
      </div>

      )}
      

      {/* Dates */}
      <div className="trip-grid" style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14 }}>
        <div style={{ display:"flex",flexDirection:"column",gap:5 }}>
          <label style={{ fontSize:10,fontWeight:800,color:C.grayL,letterSpacing:"1.5px",textTransform:"uppercase" }}>📅 Departure Date</label>
          <input type="date" value={date} min={TODAY} onChange={e=>setTripState(s=>({...s,date:e.target.value}))} className="edit-field"
            style={{ padding:"12px 14px",borderRadius:12,border:`1.5px solid ${C.border}`,fontSize:14,fontFamily:F.body,color:C.dark,background:"#f8f9fd",width:"100%",colorScheme:"light" }} />
        </div>

        {tripType === "round" && (
          <div style={{ display:"flex",flexDirection:"column",gap:5 }}>
            <label style={{ fontSize:10,fontWeight:800,color:"#b8860b",letterSpacing:"1.5px",textTransform:"uppercase" }}>🔁 Return Date</label>
            <input type="date" value={returnDate} min={date||TODAY} onChange={e=>setTripState(s=>({...s,returnDate:e.target.value}))} className="edit-field"
              style={{ padding:"12px 14px",borderRadius:12,border:`1.5px solid ${C.gold}`,fontSize:14,fontFamily:F.body,color:C.dark,background:"#fffdf0",width:"100%",colorScheme:"light" }} />
          </div>
        )}
      </div>

      {/* Days preview banner */}
      {tripType === "round" && date && returnDate && (
        <div className="return-banner" style={{ marginBottom:14 }}>
          <span style={{ fontSize:18 }}>🗓️</span>
          <span>
            <strong>{calcTripDays(date, returnDate)} day{calcTripDays(date,returnDate)>1?"s":""}</strong> trip · prices shown will be multiplied accordingly
          </span>
        </div>
      )}

      {/* Via cities summary pill */}
      {stops.filter(s=>s.value.trim()).length > 0 && (
        <div style={{ background:"rgba(245,197,24,.08)",border:"1px solid rgba(245,197,24,.25)",borderRadius:10,padding:"9px 12px",marginBottom:14,fontSize:12,color:C.gray }}>
          📍 Route: <strong style={{ color:C.dark }}>{pickup.split(",")[0]}</strong>
          {stops.filter(s=>s.value.trim()).map(s => (
            <span key={s.id}> → <strong style={{ color:C.dark }}>{s.value.split(",")[0]}</strong></span>
          ))}
          {" "} → <strong style={{ color:C.dark }}>{destination.split(",")[0]}</strong>
        </div>
      )}

      <button className="search-btn" onClick={onSearch}
        style={{ width:"100%",padding:"14px",borderRadius:50,border:"none",background:`linear-gradient(135deg,${C.gold},${C.goldD})`,color:C.dark,fontSize:15,fontWeight:800,fontFamily:F.display,cursor:"pointer",boxShadow:`0 6px 24px rgba(245,197,24,.32)`,transition:"all .25s",display:"flex",alignItems:"center",justifyContent:"center",gap:8 }}>
        🔍 Update Search
      </button>
    </div>
  );
}

/* ── Main ── */
export default function FindDrivers() {
  const { state } = useLocation();
  const trip     = state?.trip;
  const cabsData = state?.cabsData;

  const [cabs,          setCabs]         = useState(cabsData || []);
  const [loading,       setLoading]      = useState(false);
  const [showEditPanel, setShowEditPanel]= useState(false);
  const [tripState,     setTripState]    = useState({
    pickup:      trip.pickup      || "",
    destination: trip.destination || "",
    date: trip.startDate ? (trip.startDate.length>10 ? trip.startDate.slice(0,10) : trip.startDate) : TODAY,
    returnDate:  trip.endDate     || "",
    vehicleType: "sedan",
    tripType:    trip.endDate ? "round" : "one",
    // Initialise stops from incoming trip state (populated if user came from Home.jsx)
    stops: (trip.stops || []).map((v, i) => ({ id: Date.now() + i, value: v })),
  });
  const [showScroll,    setShowScroll]   = useState(false);
  const [sortBy,        setSortBy]       = useState("Price: Low to High");
  const [typeFilter,    setTypeFilter]   = useState("All");
  const [bookingDriver, setBookingDriver]= useState(null);
  const [searchKey,     setSearchKey]    = useState(0);

  const pickupRef = useRef();
  const dropRef   = useRef();
  const stopRefs  = useRef({}); // keyed by stop.id

  const vehicleMap = { Sedan:"sedan", SUV:"suv", Innova:"innova", Hatchback:"hatchback", PremiumSuv:"premium_suv" };

  const tripDays = tripState.tripType === "round" ? calcTripDays(tripState.date, tripState.returnDate) : 1;

  // ── Google Places: pickup & drop ─────────────────────────────────────────
  useEffect(() => {
    if (!window.google || !pickupRef.current) return;
    const ac = new window.google.maps.places.Autocomplete(pickupRef.current, { types:["geocode"], componentRestrictions:{country:"in"} });
    ac.addListener("place_changed", () => { const p=ac.getPlace(); setTripState(s=>({...s,pickup:p.formatted_address})); });
  }, [showEditPanel]);

  useEffect(() => {
    if (!window.google || !dropRef.current) return;
    const ac = new window.google.maps.places.Autocomplete(dropRef.current, { types:["geocode"], componentRestrictions:{country:"in"} });
    ac.addListener("place_changed", () => { const p=ac.getPlace(); setTripState(s=>({...s,destination:p.formatted_address})); });
  }, [showEditPanel]);

  // ── Google Places: via stops ──────────────────────────────────────────────
  useEffect(() => {
    if (!window.google) return;
    tripState.stops.forEach(stop => {
      const el = stopRefs.current[stop.id];
      if (!el || el._acAttached) return;
      const ac = new window.google.maps.places.Autocomplete(el, { types:["geocode"], componentRestrictions:{country:"in"} });
      ac.addListener("place_changed", () => {
        const p = ac.getPlace();
        setTripState(s => ({
          ...s,
          stops: s.stops.map(st => st.id === stop.id ? { ...st, value: p.formatted_address || "" } : st),
        }));
      });
      el._acAttached = true;
    });
  }, [tripState.stops]);

  useEffect(() => { if (trip.vehicle) setTypeFilter(trip.vehicle); }, [trip.vehicle]);
  useEffect(() => { window.scrollTo({top:0,behavior:"smooth"}); }, []);
  useEffect(() => { const fn=()=>setShowScroll(window.scrollY>300); window.addEventListener("scroll",fn); return ()=>window.removeEventListener("scroll",fn); }, []);

  const fetchCabs = async () => {
    try {
      setLoading(true);
      setCabs([]);

      // Build via_cities list from stops
      const viaCities = tripState.stops.map(s => s.value.trim()).filter(Boolean);

      const res = await axios.get("https://prashantbha.pythonanywhere.com/api/find-cabs/", {
        params: {
  pickup:       tripState.pickup,
  drop:         tripState.destination,
  vehicle_type: vehicleMap[tripState.vehicleType],
  date:         tripState.date,

  // IMPORTANT
  return_date:
    tripState.tripType === "round"
      ? tripState.returnDate
      : "",

  trip_type:
    tripState.tripType === "round"
      ? "round"
      : "one",

  ...(viaCities.length
    ? { via_cities: viaCities.join(",") }
    : {}),
},
      });
      console.log("API RESPONSE:", res.data);
      setCabs(res.data.cabs || []);
    } catch (err) {
      console.error("API ERROR:", err);
    } finally {
      setLoading(false);
    }
  };

  // tripData passed into BookingFormModal — includes stops array
  const tripData = useMemo(() => ({
    pickup:      tripState.pickup,
    destination: tripState.destination,
    date:        tripState.date,
    returnDate:  tripState.tripType === "round" ? tripState.returnDate : "",
    stops:       tripState.stops.map(s => s.value.trim()).filter(Boolean),
  }), [tripState.pickup, tripState.destination, tripState.date, tripState.returnDate, tripState.tripType, tripState.stops]);

  const handleSearch = async () => {
    await fetchCabs();
    if (tripState.vehicleType && tripState.vehicleType !== "All") setTypeFilter(vehicleMap[tripState.vehicleType] || "All");
    setSearchKey(k=>k+1);
    setShowEditPanel(false);
    window.scrollTo({top:0,behavior:"smooth"});
  };

  const sorted = [...cabs]
    .filter(d => typeFilter==="All" || d.type?.toLowerCase()===typeFilter?.toLowerCase())
    .sort((a,b) => {
      if (sortBy==="Price: Low to High") return a.total_price - b.total_price;
      if (sortBy==="Price: High to Low") return b.total_price - a.total_price;
      if (sortBy==="Rating") return b.driver?.rating - a.driver?.rating;
      if (sortBy==="ETA") return a.eta_minutes - b.eta_minutes;
      return 0;
    });

  // Active via stops count (for summary bar)
  const activeStops = tripState.stops.filter(s => s.value.trim());

  return (
    <>
      <SEO page="findDrivers" trip={tripState} />
      <Toaster position="top-right" toastOptions={{ duration:3000, style:{ background:"#1a1a2e", color:"#f5c518", borderRadius:"14px", fontWeight:"600" } }} />
      <style>{CSS}</style>
      <div style={{ fontFamily:F.body,background:C.bg,minHeight:"100vh",color:"#1a1a1a",overflowX:"hidden" }}>
        <Header defaultActive="Find Drivers" />

        <div style={{ maxWidth:960,margin:"0 auto",padding:"clamp(16px,3vw,24px) clamp(14px,3vw,20px) 60px" }}>

          {/* Page heading */}
          <div style={{ marginBottom:16,animation:"fadeUp .5s ease both" }}>
            <h1 style={{ fontFamily:F.display,fontSize:"clamp(22px,5vw,32px)",fontWeight:800,color:C.dark,marginBottom:4 }}>Available Cabs</h1>
            <p style={{ fontSize:13,color:C.gray }}>
              {tripState.pickup||"Your location"} → {tripState.destination||"Destination"}
              {activeStops.length > 0 && (
                <span style={{ color:C.goldD,fontWeight:600 }}>
                  {" "}(via {activeStops.map(s=>s.value.split(",")[0]).join(", ")})
                </span>
              )}
              {tripState.date && <span> · 📅 {displayDate(tripState.date)}</span>}
              {tripState.tripType==="round" && tripState.returnDate && (
                <span style={{ color:C.goldD,fontWeight:600 }}> → 🔁 {displayDate(tripState.returnDate)} ({tripDays} day{tripDays>1?"s":""})</span>
              )}
              {" · "}<span style={{ color:C.green,fontWeight:600 }}>{sorted.length} cabs found</span>
            </p>
          </div>

          {/* Trip Summary Bar */}
          {!showEditPanel && (
            <div className="trip-summary-bar" onClick={()=>setShowEditPanel(true)}>
              <div style={{ display:"flex",alignItems:"center",gap:10,minWidth:0 }}>
                <div style={{ width:34,height:34,borderRadius:10,background:`linear-gradient(135deg,${C.gold},${C.goldD})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0 }}>✏️</div>
                <div style={{ minWidth:0 }}>
                  <div style={{ fontWeight:700,fontSize:14,color:C.dark,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap" }}>
                    {tripState.pickup.split(",")[0]} → {tripState.destination.split(",")[0]}
                  </div>
                  <div style={{ fontSize:12,color:C.grayL,marginTop:1 }}>
                    {displayDate(tripState.date)}
                    {tripState.tripType==="round" && tripState.returnDate && (
                      <span style={{ color:C.goldD,fontWeight:600 }}> · Return: {displayDate(tripState.returnDate)} · {tripDays} day{tripDays>1?"s":""}</span>
                    )}
                    {activeStops.length > 0 && (
                      <span style={{ color:C.goldD,fontWeight:600 }}> · Via: {activeStops.map(s=>s.value.split(",")[0]).join(", ")}</span>
                    )}
                    {tripState.tripType==="round" ? " · 🔁 Round Trip" : " · 🛫 One Way"}
                  </div>
                </div>
              </div>
              <div style={{ display:"flex",alignItems:"center",gap:6,background:"rgba(245,197,24,.1)",border:"1px solid rgba(245,197,24,.3)",borderRadius:50,padding:"6px 14px",flexShrink:0 }}>
                <span style={{ fontSize:12,fontWeight:700,color:C.goldD,whiteSpace:"nowrap" }}>✏ Modify Trip</span>
              </div>
            </div>
          )}

          {/* Edit Panel */}
          {showEditPanel && (
            <TripEditPanel
              tripState={tripState}
              setTripState={setTripState}
              onSearch={handleSearch}
              pickupRef={pickupRef}
              dropRef={dropRef}
              stopRefs={stopRefs}
              onClose={()=>setShowEditPanel(false)}
            />
          )}

          {/* Sort control */}
          <div className="controls-bar" style={{ display:"flex",justifyContent:"flex-end",alignItems:"center",gap:10,marginBottom:16,animation:"fadeUp .5s .1s ease both" }}>
            <select className="sort-sel" value={sortBy} onChange={e=>setSortBy(e.target.value)}
              style={{ borderRadius:50,padding:"8px 14px",fontSize:"clamp(11px,2.5vw,13px)",fontFamily:F.body,outline:"none",cursor:"pointer",background:C.white,color:"#1a1a1a",border:`1px solid ${C.border}` }}>
              {SORT_OPTIONS.map(o=><option key={o} value={o}>{o}</option>)}
            </select>
          </div>

          {/* Loading */}
          {loading && (
            <div style={{ display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"80px 0" }}>
              <div style={{ width:60,height:60,border:"6px solid #e5e7eb",borderTop:`6px solid ${C.gold}`,borderRadius:"50%",animation:"spin 1s linear infinite" }} />
              <p style={{ marginTop:16,fontWeight:600,color:C.gray }}>Finding best cabs for you...</p>
            </div>
          )}

          {/* Cab Cards */}
          <div key={searchKey} style={{ display:"flex",flexDirection:"column",gap:14 }}>
            {!loading && (
              sorted.length===0 ? (
                <div style={{ textAlign:"center",padding:"60px 0",color:C.gray }}>
                  <div style={{ fontSize:48,marginBottom:12 }}>🚫</div>
                  <p style={{ fontWeight:600,marginBottom:8 }}>No cabs found.</p>
                  <p style={{ fontSize:13 }}>Try modifying your search above.</p>
                </div>
              ) : (
                sorted.map(cab => {
                  const driver = {
                    id:           cab.key || cab.id,
                    vehicle:      cab.vehicle,
                    type:         cab.type,
                    status:       cab.status,
                    price:        Number(cab.total_price || 0),
                    fuel:         cab.fuel,
                    distance:     cab.distance_km || 0,
                    price_per_km: cab.pricePerKm || 0,
                    eta:          cab.eta_minutes ? `${cab.eta_minutes} mins` : "5 mins",
                    rating:       cab.rating || 4.5,
                    img:          cab.img || dzire,
                  };
                  return <CabCard key={cab.key} driver={driver} onBook={setBookingDriver} tripDays={tripDays} />;
                })
              )
            )}
          </div>

          {/* Trust badges */}
          <div className="trust-grid" style={{ marginTop:32,display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,animation:"fadeUp .8s .3s ease both" }}>
            {[
              { icon:"📍",title:"Live Trip Tracking",  desc:"Track your cab in real-time with accurate updates"   },
              { icon:"🛡️",title:"Safe & Verified Drivers",desc:"Background-checked drivers for secure rides"         },
              { icon:"⚡",title:"Instant Booking",     desc:"Book your ride in seconds with quick confirmation"    },
            ].map(({icon,title,desc})=>(
              <div key={title} style={{ background:C.white,border:`1px solid ${C.border}`,borderRadius:16,padding:"14px 12px",textAlign:"center" }}>
                <div style={{ fontSize:24,marginBottom:7 }}>{icon}</div>
                <div style={{ fontFamily:F.display,fontWeight:700,fontSize:"clamp(12px,2.5vw,14px)",marginBottom:3,color:C.dark }}>{title}</div>
                <div style={{ fontSize:11,color:C.gray }}>{desc}</div>
              </div>
            ))}
          </div>
        </div>

        <Footer />

        {bookingDriver !== null && (
          <BookingFormModal key={bookingDriver.id} driver={bookingDriver} trip={tripData} onClose={()=>setBookingDriver(null)} />
        )}
      </div>

      {showScroll && (
        <button className="scroll-top" onClick={()=>window.scrollTo({top:0,behavior:"smooth"})}
          style={{ position:"fixed",right:18,bottom:24,width:48,height:48,borderRadius:"50%",border:"none",background:`linear-gradient(135deg,${C.gold},${C.goldD})`,color:C.dark,fontSize:20,cursor:"pointer",boxShadow:"0 8px 24px rgba(0,0,0,.2)",zIndex:999,display:"flex",alignItems:"center",justifyContent:"center" }}>
          ↑
        </button>
      )}
    </>
  );
}